import { useMutation, useQueryClient } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ReviewAnalysisApiService } from 'src/services/reviewAnalysisApi'

interface UseDeleteReviewAnalysisFacilityMutationParams {
  onError?: () => void
  onSuccess?: () => void
}

export const useDeleteReviewAnalysisFacilityMutation = (
  campaignId: string,
  { onError, onSuccess }: UseDeleteReviewAnalysisFacilityMutationParams = {}
) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (facilityId: string) =>
      ReviewAnalysisApiService.deleteFacility(campaignId, facilityId),
    onError: () => {
      onError?.()
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QueryKey.GET_REVIEW_ANALYSIS_OVERVIEW, campaignId],
      })
      queryClient.invalidateQueries({
        queryKey: [QueryKey.GET_REVIEW_ANALYSIS_STATUS, campaignId],
      })
      queryClient.invalidateQueries({
        queryKey: [QueryKey.GET_REVIEW_ANALYSIS_CAMPAIGN, campaignId],
      })
      onSuccess?.()
    },
  })
}
